import Swiper from "swiper";
import { Pagination } from "swiper/modules";

(function () {
  const swiperSliders = document.querySelectorAll(".com-locations__slider");

  let numbersSwiper = [];

  for (let i = 0; i < swiperSliders.length; i++) {
    numbersSwiper[i] = new Swiper(swiperSliders[i], {
      modules: [Pagination],
      loop: true,
      slidesPerView: 2.1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        680: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },
    });
  }
})();
